export default "/img_score_10.png";